export default __webpack_public_path__ + "static/media/bg-hi-tech3.d7eadc86.jpg";